import { authRoles } from 'app/auth';
import UserRegistrationForm from './UserRegistrationForm';

export default {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/registration',
			component: UserRegistrationForm
		}
	]
};
